import { baseExpertActionMock } from '@techspert-io/expert-actions';
import {
  ExpertScreenerActionStatusMap,
  IExpertScreenerAction,
} from '../models/expertScreenerActions.models';
import { IScreenerMarkingResult } from '../models/screenerMarking.models';

export const baseExpertScreenerActionMock: IExpertScreenerAction = {
  ...baseExpertActionMock,
  status: ExpertScreenerActionStatusMap.Pending,
  actionType: 'screener',
  contactId: '',
  contactLookupId: '',
};

export const screenerMarkingResultMock: IScreenerMarkingResult = {
  expert_action_id: baseExpertScreenerActionMock.expertActionId,
  opportunity_id: baseExpertScreenerActionMock.opportunityId,
  survey_id: 'survey-id',
  overall_verdict: 'pass',
  summary: ['Candidate meets the marking criteria.'],
  question_verdicts: [
    {
      id: 'q1',
      question: 'How many years of experience?',
      answer: '10',
      verdict: 'pass',
      reasoning: 'Exceeds the required minimum.',
    },
    {
      id: 'q2',
      question: 'Region?',
      answer: 'APAC',
      verdict: 'failed',
      reasoning: 'Out of the targeted region.',
    },
  ],
  marking_criteria: 'At least 5 years experience in the targeted region.',
  created_at: '2026-06-11T00:00:00.000Z',
  created_by: 'system',
  updated_at: '2026-06-11T00:00:00.000Z',
  updated_by: 'system',
};
